import type { CellContext } from '@/components/ui/table/types'
import type { Project } from '@/modules/projects'

export const NumberOfPagesCell = (cell: CellContext<Project, string>) => (
  <div className="text-left">{cell.getValue()}</div>
)
